module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "american_express.688323a2.png";